import React from 'react'

function OffcanvasMenu() {
    // Get current path
    const getCurrentPath = () => {
        return window.location.pathname;
    };

    // Check if a path is active
    const isActive = (path) => {
        const currentPath = getCurrentPath();
        if (path === '/' && currentPath === '/') return true;
        if (path !== '/' && currentPath.startsWith(path)) return true;
        return false;
    };

    return (
        <>
            {/* Offcanvas area start */}
            <div className="fix">
                <div className="offcanvas__area">
                    <div className="offcanvas__wrapper">
                        <div className="offcanvas__content">
                            <div className="offcanvas__top d-flex justify-content-between align-items-center">
                                <div className="offcanvas__logo">
                                    <a href="/">
                                        <img src="assets/imgs/logo/logo.png" alt="logo not found" />
                                    </a>
                                </div>
                                <div className="offcanvas__close">
                                    <button className="offcanvas-close-icon animation--flip">
                                        <span className="offcanvas-m-lines">
                                            <span className="offcanvas-m-line line--1"></span><span className="offcanvas-m-line line--2"></span><span className="offcanvas-m-line line--3"></span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div className="mobile-menu fix">
                                <nav>
                                    <ul>
                                        <li className={isActive('/') ? 'active' : ''}>
                                            <a href="/">Home</a>
                                        </li>
                                        <li className={isActive('/printers') ? 'active' : ''}>
                                            <a href="/printers">Printers</a>
                                        </li>
                                        <li className={isActive('/solutions') ? 'active' : ''}>
                                            <a href="/solutions">Card Solutions</a>
                                        </li>
                                        <li className={isActive('/smart-cards') ? 'active' : ''}>
                                            <a href="/smart-cards">Smart Cards</a>
                                        </li>
                                        <li className={isActive('/accessories') ? 'active' : ''}>
                                            <a href="/accessories">Accessories</a>
                                        </li>
                                        <li className={isActive('/contact') ? 'active' : ''}>
                                            <a href="/contact">Contact Us</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="offcanvas__social">
                                <h3 className="offcanvas__title mb-20">Subscribe & Follow</h3>
                                <ul>
                                    <li><a href="https://facebook.com" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="https://instagram.com" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="offcanvas__overlay"></div>
            <div className="offcanvas__overlay-white"></div>
            {/* Offcanvas area end */}
        </>
    )
}

export default OffcanvasMenu
